import React, {useEffect, useState} from "react";
import {Navigate, Outlet} from "react-router-dom";
import Layout from "./layout";
import {getCurrentUser} from "../utility/api";
import {useDispatch, useSelector} from "react-redux";


const PrivateRoute = ({allowedRoles}) => {

    const userData = useSelector((state) => state.user.list);
    const {list: userDetails, loading: userDetailsLoader, countryList} = useSelector((state) => state.user);


    const token = localStorage.getItem("token");

    if (! token) {
        return <Navigate to="/"/>;
    }

    if (!userDetailsLoader) {
        if (!userDetails || !allowedRoles.includes(userDetails ?. role)) {
            return <Navigate to="/unauthorized"/>;
        }
        if (userDetails.role === "carSeller") {
            if (window.location.pathname !== "/usedCars" && window.location.pathname !== "/home") { // console.log(window.location.pathname !== "/home", "debugggggggggg");
                return <Navigate to="/unauthorized"/>;
            }
        }

    }
    return (
        <Layout>
            <Outlet/>
        </Layout>
    );
};

export default PrivateRoute;
